<template>
    <div class="tab-content" v-if="consult && consult.questions">
        <div class="qa-box" v-for="ques in consult.questions">
            <span class="title-tag bg-blue">问</span>
            <div class="qa-info">
                <h2 class="title" v-if="ques && ques.content">{{ques.content}}</h2>
                <div class="time light-gray">{{ques.createTime | date}}</div>
                <div class="qa-sub" v-if="consult.answers[ques.id]">
                    <div class="sub-wrap" v-for="ans in consult.answers[ques.id]">
                        <span class="title-tag bg-green">答</span>
                        <div class="sub-info">
                            <div class="title-wrap"><h3>{{ans.answerUserType | userType}}</h3><span
                                    class="time light-gray">{{ans.createTime | date}}</span></div>
                            <p v-if="ans && ans.content">{{ans.content}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { getPositionQuestions } from "@/api/positions";

  export default {
    props: {
      consult: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {};
    },
    methods: {},
    created() {

    }
  };
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .tab-content {
        padding: 10px 0 !important;

        .qa-box {
            padding: 15px;
            overflow: hidden;

            &:not(:last-child) {
                margin-bottom: 15px;
                padding-bottom: 15px;
                border-bottom: 0.5px solid #e5e5e5;
            }

            .title-tag {
                float: left;
                border-radius: 2px;
                width: 16px;
                height: 16px;
                text-align: center;
                line-height: 16px;
                font-size: 12px;
                margin-top: 4px;
            }

            .qa-info {
                margin-left: 30px;

                .title {
                    font-size: 16px;
                    line-height: 24px;
                    margin-bottom: 15px;
                }

                .time {
                    font-size: 12px;
                }

                .qa-sub {
                    position: relative;
                    background-color: #f4f4f4;
                    padding: 10px;
                    margin-top: 10px;
                    border-radius: 2px;

                    &:before {
                        content: '';
                        position: absolute;
                        left: 15px;
                        top: -5px;
                        display: block;
                        width: 10px;
                        height: 10px;
                        transform: rotate(45deg);
                        background-color: #f4f4f4;
                        clear: both;
                    }

                    .sub-info {
                        margin-left: 30px;
                        line-height: 24px;

                        .title-wrap {
                            display: flex;
                            align-items: center;
                            justify-content: flex-start;
                            margin-bottom: 10px;

                            h3 {
                                margin-right: 10px;
                            }

                            .time {
                                margin-left: auto;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
